import loadPurchasesByProduct from "@bevco/Store/Handlers/SpendReporting/LoadPurchasesByProduct";
import loadSpendReport from "@bevco/Store/Handlers/SpendReporting/LoadSpendReport";
import { CustomState } from "@bevco/Store/Reducers";
import { createHandlerChainRunner, Handler } from "@insite/client-framework/HandlerCreator";

type HandlerType = Handler<{ yearSelected: number; typeChart: "spend-report" | "purchases-by-product" }>;

export const DispatchSetLoading: HandlerType = props => {
    if (props.parameter.typeChart === "spend-report") {
        props.dispatch({
            type: "Custom/SpendReportingState/SetIsLoading",
            isLoading: true,
        } as any);
    }

    if (props.parameter.typeChart === "purchases-by-product") {
        props.dispatch({
            type: "Custom/PurchasesByProductState/SetIsLoading",
            isLoading: true,
        } as any);
    }
};

export const DispatchSetYearSelected: HandlerType = props => {
    if (props.parameter.typeChart === "spend-report") {
        props.dispatch({
            type: "Custom/SpendReportingState/SetYearSelected",
            yearSelected: props.parameter.yearSelected,
        } as any);
    }

    if (props.parameter.typeChart === "purchases-by-product") {
        props.dispatch({
            type: "Custom/PurchasesByProductState/SetYearSelected",
            yearSelected: props.parameter.yearSelected,
        } as any);
    }
};

export const DispatchNewYearSelected: HandlerType = props => {
    if (props.parameter.typeChart === "spend-report") {
        const {
            spendReportingState: { spendReport },
        } = props.getState() as CustomState;
        if (!spendReport[props.parameter.yearSelected]) {
            props.dispatch(loadSpendReport({}));
        } else {
            props.dispatch({
                type: "Custom/SpendReportingState/SetIsLoading",
                isLoading: false,
            } as any);
        }
    }

    if (props.parameter.typeChart === "purchases-by-product") {
        const {
            customPurchasesByProductState: { data },
        } = props.getState() as CustomState;
        if (data.year !== props.parameter.yearSelected) {
            props.dispatch(loadPurchasesByProduct({}));
        } else {
            props.dispatch({
                type: "Custom/PurchasesByProductState/SetIsLoading",
                isLoading: false,
            } as any);
        }
    }
};

export const chain = [DispatchSetLoading, DispatchSetYearSelected, DispatchNewYearSelected];

const handleYearSelected = createHandlerChainRunner(chain, "HandleYearSelected");
export default handleYearSelected;
